export type GetSolvesInfoResponseType = {
  EASY: number;
  MEDIUM: number;
  HARD: number;
};

export type ISolvesInfo = {
  easy?: number;
  medium?: number;
  hard?: number;
};

export function parseGetSolvesInfoResponse(
  response: GetSolvesInfoResponseType,
): ISolvesInfo {
  return {
    easy: response.EASY,
    medium: response.MEDIUM,
    hard: response.HARD,
  };
}
